export default "__VITE_ASSET__c6ed05e0__"